import React from "react";
import Login from "./Login";
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
} from "react-router-dom";

import ContactPage from "./ContactPage";
import MessageList from "./MessageList";
import MyAccount from "./MyAccount";
import NewPassword from "./NewPassword";
import NotFound from "./NotFound";
import OcrProcessDetails from "./OcrProcessDetails";
import OcrProcessList from "./OcrProcessList";
import PasswordReset from "./PasswordReset";
import SearchResults from "./SearchResults";
import StartPage from "./StartPage";
import BankBookingPage from "./BankBookingPage"

import { getToken, clearSessionStorage } from "../sessionStorage";

export default class AppRouter extends React.Component {
  state: {
    loggedIn: boolean;
  };

  constructor(props: any) {
    super(props);

    this.state = { loggedIn: getToken() !== null };
    this.loginCustomer = this.loginCustomer.bind(this);
  }

  loginCustomer() {
    this.setState({ loggedIn: true });
  }

  render() {
    const urlPrefix = "";

    if (!this.state.loggedIn) {
      return (
        <Router basename={urlPrefix}>
          <Switch>
            <Route
              path="/login"
              exact
              render={({ history }) => (
                <Login loginCustomer={this.loginCustomer} history={history} />
              )}
            />
            <Route path="/passwort" exact>
              <PasswordReset />
            </Route>
            <Route path="/neues_passwort/:token" component={NewPassword} />
            <Redirect to="/login" />
          </Switch>
        </Router>
      );
    }

    return (
      <Router basename={urlPrefix}>
        <Switch>
          <Route path="/" exact>
            <StartPage />
          </Route>
          <Route path="/account" exact render={({history}) => (<MyAccount history={history}/>)} />
          <Route path="/vorgaenge" exact component={OcrProcessList} />
          <Route path="/vorgaenge/:before" exact component={OcrProcessList} />
          <Route path="/buchungen" exact component={BankBookingPage} />
          <Route path="/nachrichten" exact render={({ history}) => (
            <MessageList history={history}/>
          )} />
          <Route
            path="/nachrichten/kontakt"
            exact
            render={({ history }) => (
              <MessageList showTeamModal={true} history={history} />
            )}
          />
          <Route path="/kontakt" exact>
            <ContactPage/>
          </Route>
          <Route path="/vorgang/:processNumber" component={OcrProcessDetails} />
          <Route path="/suche">
            <SearchResults/>
          </Route> 
          <Route
            path="/logout"
            exact
            render={({ history }) => {
              clearSessionStorage();
              this.setState({ ...this.state, loggedIn: false });
              history.replace("/");
              return <></>;
            }}
          />
          <Route component={NotFound} />
        </Switch>
      </Router>
    );
  }
}
